<div class="flex items-center justify-between w-full h-16 px-2 lg:px-0">

    <div class="flex items-center mr-auto">
        <div>
            <img src="./images/logo.png" class="w-10 h-auto lg:w-[60px] lg:h-[52px]" alt="NCMS UI" />
        </div>
        <div class="flex flex-col ml-2">
            <p class="text-xl lg:text-3xl">NCMS</p>
            <p class="text-xs lg:text-base font-light whitespace-nowrap">Nigeria Case Management System</p>
        </div>
    </div>

    @if(userData()) {

    <div class="hidden lg:flex flex-col items-end font-light text-sm">
        <div class="flex items-center mb-2">
            <mat-icon fontIcon="account_balance" class="mr-2"></mat-icon>
            {{userData()?.courtName}} - {{userData()?.divisionName}}
        </div>

        <div class="flex items-center space-x-3">

            <!-- Profile dropdown trigger -->
            <div class="flex items-center space-x-1 hover:text-primary " [matMenuTriggerFor]="profileMenu">
                <span class="font-medium">
                    Welcome {{ userData()?.userFullName }}
                </span>
                <span>
                    {{ getUserRole() }} | ID: {{ userData()?.activeUserId }}
                </span>

                <mat-icon class="text-current text-base">
                    expand_more
                </mat-icon>
            </div>



            <!-- Messages
                <span class="cursor-pointer" matTooltip="Messages">
                    <mat-icon fontIcon="mark_chat_unread" class="ncms-msg"></mat-icon>
                </span> -->

            <!-- Logout stays outside
                <span class="cursor-pointer" matTooltip="Logout">
                    <mat-icon
                    fontIcon="power_settings_new"
                    color="error"
                    class="ncms-logout"
                    (click)="logoutHandler()"
                    ></mat-icon>
                </span> -->

        </div>
        <mat-menu #profileMenu="matMenu" class="profile-menu" panelClass="profile-menu">
            <button mat-menu-item color="primary" (click)="navigateToChangePassword()">
                <mat-icon color="primary">lock_reset</mat-icon>
                <span>Change Password</span>
            </button>
            <button mat-menu-item color="primary" (click)="logoutHandler()">
                <mat-icon class="logout-icon">power_settings_new</mat-icon>
                <span>Log out</span>
            </button>
        </mat-menu>


    </div>

    <div class="lg:hidden">
        <button mat-icon-button [matMenuTriggerFor]="mobileMenu" aria-label="User Menu">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #mobileMenu="matMenu">
            <div class="px-4 py-2 text-sm font-bold border-b">
                {{userData()?.courtName}}
            </div>

            <div class="px-4 py-2 text-sm text-gray-600 border-b">
                <p>{{userData()?.userFullName}}</p>
                <p class="text-xs">{{getUserRole()}} | ID: {{userData()?.activeUserId}}</p>
            </div>

            <button mat-menu-item>
                <mat-icon class="ncms-msg">mark_chat_unread</mat-icon>
                <span>Messages</span>
            </button>

            <button mat-menu-item (click)="navigateToChangePassword()">
                <mat-icon class="ncms-change-password">lock_reset</mat-icon>
                <span>Change Password</span>
            </button>

            <button mat-menu-item (click)="logoutHandler()">
                <mat-icon color="error" class="ncms-logout">power_settings_new</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>

    }
</div>